import { autoserialize, autoserializeAs } from 'cerialize';

import { BaseDTO } from './base-dto';

export class Call extends BaseDTO implements ICall {
  @autoserialize id: string;
  @autoserializeAs('lead_id') leadId: string;

  @autoserializeAs('call_sid') callSid: string;
  @autoserializeAs('call_status') callStatus: string;
  @autoserialize called: string;
  @autoserialize caller: string;
  @autoserializeAs('caller_state') callerState: string;
  @autoserializeAs('caller_zip') callerZip: string;
  @autoserializeAs('caller_city') callerCity: string;

  @autoserializeAs('created_at') createdAt: string;

  @autoserializeAs('task_sid') taskSid: string;
  @autoserializeAs('reservation_sid') reservationSid: string;
  @autoserializeAs('worker_sid') workerSid: string;

  @autoserializeAs('conference_sid') conferenceSid: string;
  @autoserializeAs('forwarded_from') forwardedFrom: string;
  @autoserializeAs('forwarded_to') forwardedTo: string;

  @autoserializeAs('voicemail_recording_ids') voicemailRecordingIds: string[];
  @autoserializeAs('call_recording_ids') callRecordingIds: string[];

  @autoserializeAs('recording_status') recordingStatus: string;
  @autoserializeAs('recording_sid') recordingSid: string;
  @autoserializeAs('recording_duration') recordingDuration: string;

  @autoserializeAs('owner_id') ownerId: string;
  @autoserializeAs('owner_type') ownerType: string;

  @autoserializeAs('no_schedule_reason') noScheduleReason: string;
  @autoserializeAs('require_follow_up') requireFollowUp: boolean;
  @autoserialize note: string;
  @autoserialize agent_name: string;

  @autoserializeAs('call_context') callContext: string;

  constructor(payload: ICall) {
    super();

    this.id = payload?.id;
    this.leadId = payload?.leadId;
    this.callSid = payload?.callSid;
    this.callStatus = payload?.callStatus;
    this.called = payload?.called;
    this.caller = payload?.caller;
    this.callerState = payload?.callerState;
    this.callerZip = payload?.callerZip;
    this.callerCity = payload?.callerCity;

    this.createdAt = payload?.createdAt;

    this.taskSid = payload?.taskSid;
    this.reservationSid = payload?.reservationSid;
    this.workerSid = payload?.workerSid;

    this.conferenceSid = payload?.conferenceSid;
    this.forwardedFrom = payload?.forwardedFrom;
    this.forwardedTo = payload?.forwardedTo;

    this.voicemailRecordingIds = payload?.voicemailRecordingIds || [];
    this.callRecordingIds = payload?.callRecordingIds || [];

    this.recordingStatus = payload?.recordingStatus;
    this.recordingSid = payload?.recordingSid;
    this.recordingDuration = payload?.recordingDuration;

    this.ownerId = payload?.ownerId;
    this.ownerType = payload?.ownerType;

    this.noScheduleReason = payload?.noScheduleReason;
    this.requireFollowUp = payload?.requireFollowUp;
    this.note = payload?.note;

    this.callContext = payload?.callContext;
    this.agent_name = payload?.agent_name;
  }
}

export interface ICall {
  id: string;
  leadId: string;

  callSid: string;
  callStatus: string;
  called: string;
  caller: string;
  callerState: string;
  callerZip: string;
  callerCity: string;

  createdAt: string;

  taskSid: string;
  reservationSid: string;
  workerSid: string;

  conferenceSid: string;
  forwardedFrom: string;
  forwardedTo: string;

  callRecordingIds: string[];
  voicemailRecordingIds: string[];

  recordingStatus: string;
  recordingSid: string;
  recordingDuration: string;

  noScheduleReason: string;
  requireFollowUp: boolean;
  note: string;

  callContext: string;

  ownerId: string;
  ownerType: string;

  agent_name: string;
}
